import { render } from "./index.vue?vue&type=template&id=da4beabc&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=da4beabc&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=da4beabc&lang=scss"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4beabc"]])

export default __exports__